<template>
  <div class="forget">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->

    <div class="forget-canter">
      <div class="steps-top">
        <el-steps :active="active" finish-status="success" simple>
          <el-step title="1 填写信息"/>
          <el-step title="2 重置密码"/>
          <el-step title="3 密码重置成功"/>
        </el-steps>
      </div>
      <div class="forget-form">
        <div v-if="active === 1">
          <p class="steps-tips">请输入您手机号码，验证通过后即可重置密码。</p>
          <div class="forget-form-center">
            <div class="form-item">
              <div class="form-item-key">手机号</div>
              <div class="form-item-val">
                <el-input v-model="mobile" class="form-input" placeholder="请输入您的手机号码"/>
              </div>
            </div>
            <div class="form-item">
              <div class="form-item-key">验证码</div>
              <div class="form-item-val">
                <el-input v-model="nextForm.sms_code" class="form-input-code" placeholder="请输入验证码"/>
                <div class="send-code" @click="onSendCode">{{ btn_text }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="active === 2">
          <p class="steps-tips"><i class="icon el-icon-success"/>您的验证已经成功通过，请立即修改您的登录密码</p>
          <div class="forget-form-center">
            <div class="form-item">
              <div class="form-item-key">新的密码登录</div>
              <div class="form-item-val">
                <el-input v-model="password" class="form-input" type="password" placeholder="请输入新的密码登录"/>

              </div>
            </div>
            <div class="pwd-tips"><i class="icon el-icon-warning"/>6-32位字符，可使用字母、数字和符号任意组合</div>
            <div class="form-item">
              <div class="form-item-key">确认登录密码</div>
              <div class="form-item-val">
                <el-input v-model="password2" class="form-input" type="password" placeholder="请再次输入登录密码"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="active === 3">
          <p class="steps-tips"><i class="icon el-icon-success"/>您的密码重置成功，快去登录吧~</p>
          <div class="forget-form-center">
            <img class="success-icon" :src="`${IMG_URL}/images/success.png`" alt="">
          </div>
        </div>

        <div class="next-btn" @click="onNextForm">{{ active === 1 ? '下一步' : active === 2 ? '提 交' : '完 成' }}</div>
      </div>

    </div>
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import footerBox from "@/components/footerBox/index"
import { apiSmsCheck, apiUserResetPwd, apiSendSms} from '@/api/api'
export default {
  name: 'Forget',
  components: {headerNav, footerBox},
  data() {
    return {
      btn_text: '获取验证码',
      active: 1,
      mobile: '',
      password: '',
      password2: '',
      nextForm: {
        mobile: '',
        sms_code: '',
        event: 'forget',
        email: '',
        type: 'mobile'
      },
      codeNum: 60,
      closeTime: '',
      isSend: true
    }
  },
  mounted() {

  },
  methods: {
    checkPhone() {
      if (!this.mobile) {
        this.$message.info('请输入手机号码');
        return false
      } else {
        var reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
        if (!reg.test(this.mobile)) {
          this.$message.info('手机号格式不正确');
          return false
        }
      }
      return true
    },
    onSendCode() {
      if (this.checkPhone()) {
        if (this.codeNum === 60 && this.isSend) {
          this.isSend = false
          var param = {
            mobile: this.mobile,
            event: 'forget',
            type: 'mobile',
            email: this.mobile
          }
          apiSendSms(param).then(res => {
            this.$message.success('已发送')
            this.closeTime = setInterval(() => {
              if (this.codeNum > 0) {
                this.codeNum--
                this.btn_text = this.codeNum + 's'
              } else {
                this.codeNum = 60
                this.btn_text = '获取验证码'
                this.isSend = true
                clearInterval(this.closeTime)
              }
            }, 1000)
          })
        }
      }
    },
    onNextForm() {
      if (this.active === 1) {
        if (this.checkPhone()) {
          if (!this.nextForm.sms_code) {
            this.$message.info('请输入验证码');
            return false
          }
          this.nextForm.mobile = this.mobile
          this.nextForm.email = this.mobile
          apiSmsCheck(this.nextForm).then(res => {
            if (res.code === 1) {
              this.active = 2
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      } else if (this.active === 2) {
        if (!this.password) {
          this.$message.info('请输入新密码');
          return false
        }
        if (!this.password2) {
          this.$message.info('请输入再次输入新密码');
          return false
        }
        if (this.password !== this.password2) {
          this.$message.info('两次密码不一致');
          return false
        }
        const param = {
          type: 'mobile',
          event: 'forget',
          mobile: this.mobile,
          email: this.mobile,
          sms_code: this.nextForm.sms_code,
          newpassword: this.password
        }
        apiUserResetPwd(param).then(res => {
          if (res.code === 1) {
            this.active = 3
          } else {
            this.$message.error(res.msg);

          }
        })
      } else if (this.active === 3) {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>

.forget-canter{
  height: calc(100vh - 240px);
  padding-top: 68px;
}
.forget-canter{
  width: 1300px;
  margin: 0 auto;
}
.steps-top{
  margin-top: 30px;
}
.forget-form{
  width: 90%;
  margin: 0 auto;
}
.steps-tips{
  color: #000000;
  margin: 30px 0;
  display: flex;
  align-items: center;
}
.steps-tips .icon{
  color: #6aea0d;
  margin-right: 5px;
  font-size: 18px;
}
.form-item{
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.pwd-tips{
  padding-left: 110px;
  line-height: 30px;
  color: #999999;
}
.pwd-tips .icon{
  margin-right: 5px;
  color: #2276d2;
}
.form-item-key{
  font-weight: bold;
  margin-right: 10px;
}
.form-item-val{
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.send-code{
  background-color: #0f375a;
  color: #000000;
  width: 90px;
  height: 30px;
  border-radius: 2px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.form-input{
  width: 300px;
}
.form-input-code{
  width: 200px;
}
.forget-form-center{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 60px;
}
.next-btn{
  width: 350px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: #0f375a;
  color: #000000;
  margin: 20px auto 0;
  cursor: pointer;
}
.success-icon{
  width: 300px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/forget.vue